import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Box } from '@mui/system'
import { useFormik } from "formik";
import * as yup from "yup";
import shortid from 'shortid';
import { Button, Chip, Dialog, FormControlLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import {useNavigate} from 'react-router-dom'
import ImportModal from '../../components/100/ImportModal';
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
const Request=styled(Box)(({theme})=>({
    display:'flex',
    flexDirection:'column',
    gap:'20px',
    alignSelf:'center',
    width:'70%',
    alignItems:'center',
    borderRadius:'5px',
    // background:theme.palette.background.bread,
    boxShadow: `0px 4px 4px ${theme.palette.background.shadow}`,
    paddingBottom:'100px'
}))
const Header=styled(Box)(({theme})=>({
    width:'100%',
    height: '80px',
    fontWeight: 600,
    fontSize: '32px',
    lineHeight: '20px',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
}))

const StyledForm=styled('form')(({theme})=>({
    display:'flex',
    flexDirection:'column',
    gap:'40px',
    justifyContent:'flex-start',
    width:'100%',
    padding:'10px 40px',
}))

const StyledLabel=styled('label')(({theme})=>({
    color: theme.palette.third.main,
    fontWeight: '400',
    fontSize: '15px',
    lineHeight: '20px',
}))
const StyledTextField=styled(TextField)(({theme})=>({
    "& label":{
        color: theme.palette.third.main,
        fontWeight: '400',
        fontSize: '15px',
        lineHeight: '20px',
    }
    

}))

const StyledDate=styled('input')(({theme})=>({
    width: '160px',
    height: '44px',
    background:theme.palette.background.default,
    color:theme.palette.third.main,
    border:`0.2px solid ${theme.palette.third.main}`,

}))
const Duration=styled(Box)(({theme})=>({
    display:'flex',
    flexDirection:'column',
    gap:'5px'
}))
const DurationWrapper=styled('fieldset')(({theme})=>({
    display:'flex',
    gap:'100px',
    border:`0.2px solid ${theme.palette.third.main}`,
    borderRadius:'5px',

}))
const MemberWrapper=styled('fieldset')(({theme})=>({
    display:'flex',
    flexDirection:'column',
    alignItems:'flex-start',
    gap:'20px',
    border:`0.2px solid ${theme.palette.third.main}`,
    borderRadius:'5px',

}))
const Member=styled(Box)(({theme})=>({
    display:'flex',
    justifyContent:'space-evenly',
    alignItems:'center',
    gap:'5px',
    padding:'5px',
    width:'100%',
    border:`0.2px solid ${theme.palette.third.main}`,
    borderRadius:'6px'

}))
const Buttons=styled(Box)(({theme})=>({
    display:'flex',
    justifyContent:'flex-end',
    width:'100%',
    gap:'15px',
    margin:'10px 5px'

}))

const validationSchema = yup.object({
  title: yup
    .string("Enter the Research Title")
    .required("Research Title is required"),
  gcode: yup
    .string("Enter the Research Grant Code")
    .required("Grant Code is required"),
  type: yup
    .string("Choose the Research Type")
    .required("Research Type is required")
    .oneOf(['Internal', 'External'],"Not a valid type of research"),
  institution: yup
    .string("Choose the Research Institution"),
  startDate: yup
    .date("Enter the Starting Date")
    .required("Starting Date is required"),
   endDate: yup
    .date("Enter the End Date")
    .required("End Date is required"),
  description: yup
    .string("Enter a Description for the Research")
    .required("Research Description is required"),
 role: yup
    .string("Choose your role in the Research")
    .required("Research Role is required"),
  member: yup.array("Enter the email and role of staff involved in research"),
});
export default function NewResearches() {
const api=useAxiosPrivate();
const [open,setOpen]=useState(false)
const [roles,setRoles]=useState([])
const navigate =useNavigate()
const [members,setMembers]=useState([]);
const [attachment,setAttachment]=useState()
useEffect(()=>{
      let isMounted=true;
      const controller=new AbortController();
      const getData=async ()=>{
        try{
          const response=await api.get(`research/viewRoles/`,{
            signal:controller.signal
          })
          isMounted &&  setRoles(response.data)}
        catch(err){
          console.error(err)
        }
      }
      getData();
      return ()=>{
        isMounted=false;
        controller.abort()
      }
        },[])
const AddMembers=(event)=>{
    event.preventDefault();
    setMembers(prevMembers=>[...prevMembers,{
        key:shortid.generate(),
        name:'',
        email:'',
        role:'',
        error:false,
        message:'An ALMS account under this email doesn\'t exist.'
    }])

}
const RemoveMember=(event,key)=>{

    event.preventDefault();
    setMembers(prevMembers=>
        prevMembers.filter((mem)=>mem.key!==key))
}
const EditMemberEmail= (event)=>{

    setMembers(prevMembers=>
        prevMembers.map((mem)=>mem.key===event.target.id ?{...mem,email:event.target.value}: mem)
        )
    EditMemberName(event.target.value,event.target.id)
}
const EditMemberName=async (email,key)=>{
    const name=await api.get(`/research/confirmMember/${email}`)
    // console.log(name.data)
    if(name.data.name!==null)
    {setMembers(prevMembers=>
        prevMembers.map((mem)=>mem.key===key ?{...mem, name : name.data.name}:mem)
        )}
    else
   {setMembers(prevMembers=>
        prevMembers.map((mem)=>mem.key===key ?{...mem, name :''}:mem)
        )}
    

}
const EditMemberRole=(event)=>{
    setMembers(prevMembers=>
        prevMembers.map((mem)=>mem.key===event.target.name ? {...mem,role:event.target.value} : mem)
        )
}
const ClearValue=(key)=>{
    setMembers(prevMembers=>
        prevMembers.map((mem)=>mem.key===key ?{...mem,email:'',role:'',name:''}: mem)
        )

}
const formik = useFormik({
    initialValues: {
      title: "",
      gcode: "",
      type: "",
      institution:"",
      startDate: "",
      endDate: "",
      description: "",
      role: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
    //   console.log(values);
      const result={
            title:values.title,
            g_code:values.gcode,
            type:values.type,
            institution:values.institution,
            start_date:values.startDate,
            end_date:values.endDate,
            summary:values.description,
            attachment:attachment
        }
        api
          .post("research/add", result)
          .then((response)=>{
             const file=new FormData()
             file.append("research_id",response.data.id)
             file.append("attachment",attachment)
             api
            .post("research/addAttachment", file)
            .then((response) => {
                 api
                    .post("research/addMember", {research_id:response.data,role:values.role})
                    .then(
                        (response) => {
                                    api.post("research/inviteMember", {members:members,research:values.title,research_id:response.data.research_id}).then()
                                   navigate('/researches', {state:{id:response.data.research_id,message:"Research has been requested"}})
                                         })
          })})

    },
  });
  return (
    <Request>
    <Header>
        Research Grant Request
    </Header>
        <StyledForm onSubmit={formik.handleSubmit}>
        <StyledTextField
          fullWidth
          id="title"
          label="Research Title"
          variant="standard"
          onBlur={formik.handleBlur}
          error={formik.errors.title && formik.touched.title }
          helperText={formik.touched.title && formik.errors.title}
          value={formik.values.title}
          onChange={formik.handleChange}
        />
        <StyledTextField
          fullWidth
          error={formik.errors.gcode && formik.touched.gcode}
          id="gcode"
          label="Grand Code"
          onBlur={formik.handleBlur}
          helperText={formik.touched.gcode && formik.errors.gcode}
          variant="standard"
          value={formik.values.gcode}
          onChange={formik.handleChange}
        />
        <div>
        <StyledLabel>
            Research Type
        </StyledLabel>
        <RadioGroup
            row
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="type"
            id="type"
            onBlur={formik.handleBlur}
            value={formik.values.type}
            onChange={formik.handleChange}
        >
            <FormControlLabel value="Internal" control={<Radio color='secondary' />} label="Internal" />
            <FormControlLabel value="External" control={<Radio color='secondary'/>} label="External" />
        </RadioGroup>
        </div>
        <StyledTextField
          fullWidth
          disabled={formik.values.type==="External" ? false : true}
          error={formik.errors.institution && formik.touched.institution}
          id="institution"
          label="Institution Name"
          onBlur={formik.handleBlur}
          helperText={formik.touched.institution && formik.errors.institution}
          variant="standard"
          value={formik.values.type==="External"||formik.values.type===""?formik.values.institution: "Addis Ababa Science and Technology University"}
          onChange={formik.handleChange}
        />
        <DurationWrapper>
            <legend> 
            <StyledLabel>Duration</StyledLabel>
            </legend>
        <Duration>
         <StyledLabel>
            Starting Date
        </StyledLabel>
        <StyledDate 
        type="Date"
        name='startDate'
        error={formik.errors.startDate && formik.touched.startDate}
        id="startDate"
        onBlur={formik.handleBlur}
        helperText={formik.touched.startDate && formik.errors.startDate}
        selected={formik.values.startDate}
        onChange={formik.handleChange}
        />
        </Duration>
         <Duration>
         <StyledLabel>
            Expiration Date
        </StyledLabel>
        <StyledDate 
        type="Date"
        name='endDate'
        onBlur={formik.handleBlur}
        error={formik.errors.endDate && formik.touched.endDate}
        id="endDate"
        helperText={formik.touched.endDate && formik.errors.endDate}
        selected={formik.values.endDate}
        onChange={formik.handleChange}
        />
        </Duration>
        </DurationWrapper>

         <StyledTextField
          fullWidth
          onBlur={formik.handleBlur}
          error={formik.errors.description && formik.touched.description}
          id="description"
          label="Research Description"
          multiline
          rows={4}
          helperText={formik.touched.description && formik.errors.description}
          variant="standard"
          value={formik.values.description}
          onChange={formik.handleChange}
        />
         <div>
        <StyledLabel>
            Role
        </StyledLabel>
        <RadioGroup
            row
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="role"
            id="role"
            onBlur={formik.handleBlur}
            value={formik.values.role}
            onChange={formik.handleChange}
        >
            {
                roles.map((role)=>{
                    return ( <FormControlLabel value={role.type} control={<Radio color='secondary' />} label={role.type} />)
                })
            }
            {/* <FormControlLabel value="PI" control={<Radio color='secondary' />} label="PI" />
            <FormControlLabel value="Co-PI" control={<Radio color='secondary'/>} label="Co-PI" />
            <FormControlLabel value="Member" control={<Radio color='secondary'/>} label="Member" /> */}
        </RadioGroup>
        </div>
        {/* <StyledTextField
          fullWidth
          type="number"
          error={formik.errors.load && formik.touched.load}
          id="load"
          label="Expected LEH"
                onBlur={formik.handleBlur}

          helperText={formik.touched.load && formik.errors.load}
          variant="standard"
          value={formik.values.load}
          onChange={formik.handleChange}
        /> */}
        <Duration>
        <StyledLabel>
            Contract Agreement
        </StyledLabel>
        { attachment?
          <Button variant="contained" component="label" sx={{
            width:'180px',
            bgcolor:'third.main',
            "& : hover":{
              bgcolor:'gray',
             }  
           }}
           onClick={()=>setOpen(true)}
           startIcon={<PictureAsPdfIcon />}
           >
            {attachment.path}
            </Button>:
           <Button variant="contained" component="label" sx={{
            width:'180px',
            bgcolor:'third.main',
            "& : hover":{
              bgcolor:'gray',
             }  
           }}
           onClick={()=>setOpen(true)}
           >
            Choose File
            </Button>}
        </Duration>
        <MemberWrapper >
            <legend>
            <StyledLabel>Members</StyledLabel>
            </legend>
            {
                members.map((mem,index)=>
                <Member key={index} >
                    <StyledTextField
                    type="email"
                    required
                    id={mem.key}
                    label="Email"
                    variant="standard"
                    helperText={mem.error && mem.message}
                    error={mem.error}
                    value={members[index].email}
                    onChange={EditMemberEmail}
                    sx={{
                        marginBottom:'10px'
                    }}
                    />
                    {mem.name!=='' && <Chip label={mem.name} name={mem.key} onDelete={()=>ClearValue(mem.key)} />}
                        <RadioGroup
                            row
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name={mem.key}
                            value={members[index].role}
                            onChange={EditMemberRole}
                            required
                            sx={{flexWrap:'nowrap'}}
                        >
                            {
                                roles.map((role)=>{
                                    return ( <FormControlLabel name={mem.key} value={role.type} control={<Radio color='secondary' />} label={role.type} />)
                                })
                            }
                            {/* <FormControlLabel name={mem.key} value="PI" control={<Radio color='secondary' />} label="PI" />
                            <FormControlLabel name={mem.key} value="Co-PI" control={<Radio color='secondary'/>} label="Co-PI" />
                            <FormControlLabel name={mem.key} value="Member" control={<Radio color='secondary'/>} label="Member" /> */}
                        </RadioGroup>
                        <Button id={mem.key} onClick={(event)=>RemoveMember(event,mem.key)}>
                            <DeleteIcon color='secondary'/>
                        </Button>
                </Member>
                )
            }
            <Button variant="outlined" 
                     color="secondary"
                     startIcon={<AddCircleOutlineRoundedIcon color="secondary"/>}
                     onClick={AddMembers}
                    >
                Invite Member
            </Button>
        </MemberWrapper>

        <Buttons>
                <Button variant="contained"
                onClick={()=>navigate('/researches')}
                    size="medium"
                    sx={{
                    fontWeight: 400,
                    color:'#fff',
                    bgcolor:'gray',
                    "&:hover":{
                    bgcolor:'darkGray'
                            }  }}
                    >Cancel</Button>
    <Button 
        type="submit"
        variant="contained"
        size="medium"
        // onClick={()=>{console.log(formik.values)}}
        sx={{
          bgcolor:'secondary.main',
          fontWeight: 400,
          color:'#fff',
          "&:hover":{
          bgcolor:'secondary.hover',}, }}
        >Submit Request</Button>
        </Buttons>
        </StyledForm>
        <Dialog open={open}>
          <ImportModal close={{ setOpen: setOpen, onSubmit:setAttachment, file:attachment }} />
        </Dialog>
    </Request>
  )
}
